import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=74463fdc&scoped=true&"
import script from "./ResetEmail.vue?vue&type=script&lang=js&"
export * from "./ResetEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResetEmail.vue?vue&type=style&index=0&id=74463fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74463fdc",
  null
  
)

export default component.exports